/**
 * styles.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { css } from '@emotion/react';

export const styles = {
  container: css({
    
  }),

  columns: css({
    columnGap: 16,
    padding: '12px 0',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',

    ':before': {
      display: 'none',
    },

    ':after': {
      display: 'none',
    }
  }),

  row: css({
    flexGrow: 1,
    width: '100%',
  }),

  types: css({
    
  }),

  form: css({
    
  })
}